export function show_loading_error(): void {
    document.body.classList.add("app-loading-failed");
}
